import { Component, Input, OnInit, HostBinding } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { InitNewsItems } from '../../../../redux/actions/news';
import { getNewsState } from '../../../../redux/reducers';
import { State } from '../../../../redux/reducers/news';
import { Filter } from '../../../../redux/models/news';

@Component({
  standalone: false,
  selector: 'app-news-tile',
  templateUrl: './news-tile.component.html',
  styleUrls: ['./news-tile.component.scss']
})
export class NewsTileComponent implements OnInit {
  @Input() type = 's';

  public items$: Observable<{ data: State }>;

  private readonly filter: Filter = {
    category_id: '',
    sort_by_date: 'DESC',
    search: '',
    segment_rule: 0,
    page: 1
  };

  constructor(private readonly store: Store<any>) {}

  @HostBinding() get class() {
    return 'news-tile-' + this.type;
  }

  get displayedArticlesCount(): number {
    return this.type === 'l' ? 4 : 3;
  }
  get displayedArticleTitleLength(): number {
    return this.type === 'l' || this.type === 's' ? 50 : 160;
  }

  ngOnInit() {
    this.store.dispatch(new InitNewsItems(this.filter));
    this.items$ = this.store.pipe(select(getNewsState));
  }
}
